import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import React, { Component } from "react";
import BudgetBreakdown from "../../widgets/BudgetBreakdown";
import MonthlyBudget from "../../widgets/MonthlyBudget";
import ThisMonth from "../../widgets/ThisMonth";


class Budget extends Component {
  render() {
    return (
      <Box className="dashboard-wrapper" sx={{ flexGrow: 1 }}>
        <Grid maxWidth="md" mx={"auto"}>
          <Grid container rowGap={2} columnSpacing={2}>
            <Grid item md={12} xs={12} sx={{ display: "flex" }}>
              <ThisMonth gid={this.props.gid} />
            </Grid>
            <Grid item md={12} xs={12} sx={{ display: "flex" }}>
              <MonthlyBudget gid={this.props.gid}/>
            </Grid>
            
            <Grid item md={12} xs={12} sx={{ display: "flex" }}>
              <BudgetBreakdown gid={this.props.gid} setEmbedUrl={this.props.setEmbedUrl}/>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

export default Budget;
